
import {
	Vue, Component, Watch, Prop,
} from 'vue-property-decorator';
import { Action } from 'vuex-class';

@Component
export default class DefaultModal extends Vue {
  @Action('setLoading') setLoading;

  @Prop()
  visible: boolean

  @Prop()
  title: string

  @Prop()
  btnText: string

	@Prop({default: '67%'})
  width: string

	@Prop({default: '80%'})
  height: string

  @Prop()
  btnDisabled:boolean

	@Prop({default:true})
	btnShow: boolean

	@Prop({default:false})
	closable: boolean

  modalVisible = false;

  @Watch('visible')
  onChange(val) {
    this.modalVisible = val;
  }

  onClose() {
    this.$emit('closeModal');
  }


}
